/**
 * #771: cortex-be's error handler answers every thrown HttpError as
 * `{ error: "<message>" }` (middleware/errorHandler.js), while a few older
 * branches answer `{ message }`. Callers that read only `data.message` saw
 * `undefined` on every error response and fell into a silent `console.error`.
 *
 * Returns the server's message from either field, or `fallback` when the body
 * carries neither (or is not an object).
 */
export const apiErrorMessage = (data, fallback = "") => {
  if (!data || typeof data !== "object") return fallback;
  if (typeof data.error === "string" && data.error) return data.error;
  if (typeof data.message === "string" && data.message) return data.message;
  return fallback;
};

/**
 * True for the invite/register duplicate-email responses. The invite endpoint
 * throws `ConflictError("User already invited.")` and the register path
 * `ConflictError("User already created")`, both 409; the page previously
 * matched one literal that the invite endpoint never sends.
 */
export const isDuplicateEmailError = (status, message = "") =>
  status === 409 ||
  // Message matching only for client errors: a 5xx that happens to say
  // "already exists" is a server failure, not an email the admin can change.
  (status >= 400 &&
    status < 500 &&
    /already (invited|created|exists)/i.test(message));
